var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
export var Keys;
(function (Keys) {
    Keys["Backspace"] = "Backspace";
    Keys["Clear"] = "Clear";
    Keys["Down"] = "ArrowDown";
    Keys["End"] = "End";
    Keys["Enter"] = "Enter";
    Keys["Escape"] = "Escape";
    Keys["Home"] = "Home";
    Keys["Left"] = "ArrowLeft";
    Keys["PageDown"] = "PageDown";
    Keys["PageUp"] = "PageUp";
    Keys["Right"] = "ArrowRight";
    Keys["Space"] = " ";
    Keys["Tab"] = "Tab";
    Keys["Up"] = "ArrowUp";
})(Keys || (Keys = {}));
export var MenuActions;
(function (MenuActions) {
    MenuActions[MenuActions["Close"] = 0] = "Close";
    MenuActions[MenuActions["CloseSelect"] = 1] = "CloseSelect";
    MenuActions[MenuActions["First"] = 2] = "First";
    MenuActions[MenuActions["Last"] = 3] = "Last";
    MenuActions[MenuActions["Next"] = 4] = "Next";
    MenuActions[MenuActions["Open"] = 5] = "Open";
    MenuActions[MenuActions["PageDown"] = 6] = "PageDown";
    MenuActions[MenuActions["PageUp"] = 7] = "PageUp";
    MenuActions[MenuActions["Previous"] = 8] = "Previous";
    MenuActions[MenuActions["Select"] = 9] = "Select";
    MenuActions[MenuActions["Space"] = 10] = "Space";
    MenuActions[MenuActions["Type"] = 11] = "Type";
})(MenuActions || (MenuActions = {}));
// filter an array of options against an input string
// returns an array of options that begin with the filter string, case-independent
export function filterOptions(options, filter, exclude) {
    if (options === void 0) { options = []; }
    if (exclude === void 0) { exclude = []; }
    var filterString = filter.toLowerCase().trim();
    return options.filter(function (option) {
        var matches = option.name.toLowerCase().indexOf(filterString) === 0;
        return matches && exclude.indexOf(option) < 0;
    });
}
// return an array of exact option name matches from a comma-separated string
export function findMatches(options, search) {
    var names = search.split(',');
    return names.map(function (name) {
        var match = options.filter(function (option) { return name.trim().toLowerCase() === option.name.toLowerCase(); });
        return match.length > 0 ? match[0] : null;
    })
        .filter(function (option) { return option !== null; });
}
// return combobox action from key press
export function getActionFromKey(event, menuOpen) {
    var key = event.key, altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
    var openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' ', 'Home', 'End']; // all keys that will open the combo
    // handle opening when closed
    if (!menuOpen && openKeys.includes(key)) {
        return MenuActions.Open;
    }
    // handle typing characters when open or closed
    if (key === Keys.Backspace || key === Keys.Clear || (key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)) {
        return MenuActions.Type;
    }
    // handle keys when open
    if (menuOpen) {
        if (key === Keys.Down && !altKey) {
            return MenuActions.Next;
        }
        else if (key === Keys.Up && altKey) {
            return MenuActions.CloseSelect;
        }
        else if (key === Keys.Up) {
            return MenuActions.Previous;
        }
        else if (key === Keys.Home) {
            return MenuActions.First;
        }
        else if (key === Keys.End) {
            return MenuActions.Last;
        }
        else if (key === Keys.PageUp) {
            return MenuActions.PageUp;
        }
        else if (key === Keys.PageDown) {
            return MenuActions.PageDown;
        }
        else if (key === Keys.Escape) {
            return MenuActions.Close;
        }
        else if (key === Keys.Enter) {
            return MenuActions.CloseSelect;
        }
        else if (key === Keys.Space) {
            return MenuActions.Space;
        }
    }
}
// return the index of an option from an array of options, based on a search string
// if the filter is multiple iterations of the same letter (e.g "aaa"), then cycle through first-letter matches
export function getIndexByLetter(options, filter, startIndex) {
    if (startIndex === void 0) { startIndex = 0; }
    var orderedOptions = __spread(options.slice(startIndex), options.slice(0, startIndex));
    var firstMatch = filterOptions(orderedOptions, filter)[0];
    var allSameLetter = function (array) { return array.every(function (letter) { return letter === array[0]; }); };
    // first check if there is an exact match for the typed string
    if (firstMatch) {
        return options.indexOf(firstMatch);
    }
    // if the same letter is being repeated, cycle through first-letter matches
    else if (allSameLetter(filter.split(''))) {
        var matches = filterOptions(orderedOptions, filter[0]);
        return options.indexOf(matches[0]);
    }
    // if no matches, return -1
    else {
        return -1;
    }
}
// get updated option index
export function getUpdatedIndex(current, max, action) {
    switch (action) {
        case MenuActions.First:
            return 0;
        case MenuActions.Last:
            return max;
        case MenuActions.Previous:
            return Math.max(0, current - 1);
        case MenuActions.Next:
            return Math.min(max, current + 1);
        default:
            return current;
    }
}
// check if an element is currently scrollable
export function isScrollable(element) {
    return element && element.clientHeight < element.scrollHeight;
}
// ensure given child element is within the parent's visible scroll area
export function maintainScrollVisibility(activeElement, scrollParent) {
    var offsetHeight = activeElement.offsetHeight, offsetTop = activeElement.offsetTop;
    var parentOffsetHeight = scrollParent.offsetHeight, scrollTop = scrollParent.scrollTop;
    var isAbove = offsetTop < scrollTop;
    var isBelow = (offsetTop + offsetHeight) > (scrollTop + parentOffsetHeight);
    if (isAbove) {
        scrollParent.scrollTo(0, offsetTop);
    }
    else if (isBelow) {
        scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
    }
}
// generate unique ID, the quick 'n dirty way
var idIndex = 0;
export function uniqueId() {
    return "accessible-multiselect-" + ++idIndex;
}
